import script from "./PeleadorSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PeleadorSelect.vue?vue&type=script&setup=true&lang=js"

import "./PeleadorSelect.vue?vue&type=style&index=0&id=5b6b67b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6b67b6"]])

export default __exports__